import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import SearchController from "./controllers/search_controller"
import ComparisonChartController from "./controllers/comparison_chart_controller"
import MarketFinderController from "./controllers/market_finder_controller"
import SaveSearchController from "./controllers/save_search_controller"
import AlertBuilderController from "./controllers/alert_builder_controller"
import AlertRunnerController from "./controllers/alert_runner_controller"
import AlertResultsController from "./controllers/alert_results_controller"
import SidebarController from "./controllers/sidebar_controller"
import NotificationDrawerController from "./controllers/notification_drawer_controller"
import EducationDrawerController from "./controllers/education_drawer_controller"
import MarketMapController from "./controllers/market_map_controller"
import ImportMonitorController from "./controllers/import_monitor_controller"
import UploadProgressController from "./controllers/upload_progress_controller"
import RebuildMonitorController from "./controllers/rebuild_monitor_controller"
import CleanupMonitorController from "./controllers/cleanup_monitor_controller"
import BulkGeocodeMonitorController from "./controllers/bulk_geocode_monitor_controller"
import GsFullIngestMonitorController from "./controllers/gs_full_ingest_monitor_controller"
import GsExtractionRunMonitorController from "./controllers/gs_extraction_run_monitor_controller"
import GsBulkDiscoveryMonitorController from "./controllers/gs_bulk_discovery_monitor_controller"
import DragSortController from "./controllers/drag_sort_controller"
import MultiselectController from "./controllers/multiselect_controller"
import QuickFinderController from "./controllers/quick_finder_controller"
import PortfolioController from "./controllers/portfolio_controller"
import PortfolioFormController from "./controllers/portfolio_form_controller"
import ExploreController from "./controllers/explore_controller"
import MarketScanMonitorController from "./controllers/market_scan_monitor_controller"
import ScanPickerController from "./controllers/scan_picker_controller"
import GsPendingBannerController from "./controllers/gs_pending_banner_controller"
import GsTabsController from "./controllers/gs_tabs_controller"
import GsScanListController from "./controllers/gs_scan_list_controller"
import GsDiscoveryMonitorController from "./controllers/gs_discovery_monitor_controller"
import GsProjectMonitorController from "./controllers/gs_project_monitor_controller"
import MfGridsignalController from "./controllers/mf_gridsignal_controller"
import GsWatchlistFiltersController from "./controllers/gs_watchlist_filters_controller"
import GsSignalsCarouselController from "./controllers/gs_signals_carousel_controller"
import TierASeedController from "./controllers/tier_a_seed_controller"
import GsMarketSearchController from "./controllers/gs_market_search_controller"
import CoordBackfillController from "./controllers/coord_backfill_controller"

const application = Application.start()
application.register("search", SearchController)
application.register("comparison-chart", ComparisonChartController)
application.register("market-finder", MarketFinderController)
application.register("save-search", SaveSearchController)
application.register("alert-builder", AlertBuilderController)
application.register("alert-runner", AlertRunnerController)
application.register("alert-results", AlertResultsController)
application.register("sidebar", SidebarController)
application.register("notification-drawer", NotificationDrawerController)
application.register("education-drawer", EducationDrawerController)
application.register("market-map", MarketMapController)
application.register("import-monitor", ImportMonitorController)
application.register("upload-progress", UploadProgressController)
application.register("rebuild-monitor", RebuildMonitorController)
application.register("cleanup-monitor", CleanupMonitorController)
application.register("bulk-geocode-monitor", BulkGeocodeMonitorController)
application.register("gs-full-ingest-monitor", GsFullIngestMonitorController)
application.register("gs-extraction-run-monitor", GsExtractionRunMonitorController)
application.register("gs-bulk-discovery-monitor", GsBulkDiscoveryMonitorController)
application.register("drag-sort", DragSortController)
application.register("multiselect", MultiselectController)
application.register("quick-finder", QuickFinderController)
application.register("portfolio", PortfolioController)
application.register("portfolio-form", PortfolioFormController)
application.register("explore", ExploreController)
application.register("market-scan-monitor", MarketScanMonitorController)
application.register("scan-picker", ScanPickerController)
application.register("gs-pending-banner", GsPendingBannerController)
application.register("gs-tabs", GsTabsController)
application.register("gs-scan-list", GsScanListController)
application.register("gs-discovery-monitor", GsDiscoveryMonitorController)
application.register("gs-project-monitor", GsProjectMonitorController)
application.register("mf-gridsignal", MfGridsignalController)
application.register("gs-watchlist-filters", GsWatchlistFiltersController)
application.register("gs-signals-carousel", GsSignalsCarouselController)
application.register("tier-a-seed", TierASeedController)
application.register("coord-backfill", CoordBackfillController)
application.register("gs-market-search", GsMarketSearchController)
